<template>
    <div class="learning_center">
        <div class="line"></div>
        <div class="learning_wraper">
            <div class="inner">
                <div class="personal_info">
                    <div class="header_line"></div>
                    <div class="personal_inner">
                        <div class="header">
                            <div class="user_img">
                                <el-image
                                    style="width: 120px; height: 120px;border-radius:6px;overflow:hidden;"
                                    :src="$store.getters.avatar||avatardefauter"
                                    fit="scale-down"></el-image>
                            </div>
                            <div class="user_name">{{$store.getters.name?$store.getters.name:'暂无'}}</div>
                        </div>
                        <div class="personal_detail">
                            <div class="detail detail_top">
                                <div class="gender">性别：{{$store.getters.gender?$store.getters.gender==0?'男':'女':'暂无'}}</div>
                                <div>手机号：{{$store.getters.phone?$store.getters.phone:'暂无'}}</div>
                            </div>
                            <div class="detail detail_bottom">
                                <div>身份证号：{{$store.state.user.idCard?$store.state.user.idCard:'暂无'}}</div>
                                <div>身份证正反面：{{!$store.state.user.profile.idPicFront?'未上传':'已上传'}}</div>
                                <div>人脸识别：{{!$store.state.user.profile.facePic?'未上传':'已上传'}}</div>
                                <div>地址：{{$store.state.user.profile.address|address}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="learning_detail">
                    <div class="detail_item detail_item_left">
                        <div class="item">
                            <a ref="javascript:;" :class="['item_nav',navActive===index?'active':'']" v-for="(item,index) in nav" :key="index" @click="handleSelect(index)">{{item}}</a>
                        </div>
                    </div>
                    <div class="detail_item detail_item_right">
                        <transition name="fade-transform" mode="out-in">
                            <component 
                            :is="selectTemplate" 
                            @setHandleDetail="getHandleDetail" 
                            @setCallBack="getCallBack" 
                            :learing-detail="learingDetail"
                            :is-show="isShow"></component>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LearningNow from '@/components/LearningCenterComponents/LearningNow'
import LearningRecord from '@/components/LearningCenterComponents/LearningRecord'
import PersonalInformation from '@/components/LearningCenterComponents/PersonalInformation'
import LearningDetails from '@/components/LearningCenterComponents/LearningDetails'

export default {
    name:'LearningCenter',
    components:{
        LearningNow,LearningRecord,PersonalInformation,LearningDetails
    },
    data(){
        return {
            avatardefauter:require('@/assets/images/avatardefauter.png'),
            // '当前学习'
            nav:['学习记录','个人信息'],
            navActive:0,
            // 'LearningNow',
            templates:['LearningRecord','PersonalInformation'],
            selectTemplate:'LearningRecord',
            learingDetail:{},
            isShow:true
        }
    },
    filters:{
        address(data){
            const adderss = data?JSON.parse(data):null
            return adderss?`${adderss.provinceName}${adderss.cityName?'-'+adderss.cityName:''}${adderss.townName?'-'+adderss.townName:''}`:'暂未完善'
        }
    },
    created(){
 this.$store.commit('user/SET_TABINDEX',3);
    },
    methods:{
        handleSelect(i){
            this.navActive = i
            this.selectTemplate = this.templates[i]
        },
        getHandleDetail(data){
            if(data.studyProgress != undefined){
                let rourl =  this.$router.resolve({path:"/coursedetails",query:{id:data.courseId,chapterId:data.chapterId,professionId:data.professionId}});
                window.open(rourl.href);
            }else{
                this.isShow = (this.navActive == 1? true : false)
                this.learingDetail = data
                this.selectTemplate = 'LearningDetails'
            }
        },
        getCallBack(){
            this.selectTemplate = this.templates[this.navActive]
        }
    }
}
</script>
<style lang="scss" scoped>
.learning_center{
    background: #F5F5F5;
    padding-bottom: 31px;
    .line{
        height: 63px;
        background: #fff;
        box-shadow: 0px 3px 3px #e5e5e5;
    }
    .learning_wraper{
        margin-top: -63px;
        .personal_info{
            overflow: hidden;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            position: relative;
            margin-bottom: 20px;
        }
        .header_line{
            height: 73px;
            background:#3964E6;
        }
        .personal_inner{
            padding-left: 209px;
            background: #fff;
            
            .header{
                position: relative;
                padding-top: 10px;
                margin-bottom: 29px;
                .user_img{
                    padding: 5px;
                    border-radius: 6px;
                    background: #fff;
                    position: absolute;
                    left: -159px;
                    top: -33px;
                }
                .user_name{
                    font-size: 20px;
                    font-weight: bold;
                    color: #333333;
                    line-height: 1.3;
                }
            }
            .personal_detail{
                padding-bottom: 13px;
                font-weight: bold;
                color: #333333;
                .detail{
                    display: flex;
                }
                .detail_top{
                    margin-bottom: 19px;
                    .gender{
                        margin-right: 49px;
                    }
                }
                .detail_bottom{
                    justify-content: space-between;
                    padding-right: 50px;
                }
            }
        }
        .learning_detail{
            display: flex;
            justify-content: space-between;
            .detail_item{
                border-radius: 20px;
                overflow: hidden;
                &.detail_item_left{
                    width: 25%;
                }
                &.detail_item_right{
                    width: 73%;
                }
                .item{
                    min-height: 570px;
                    background: #fff;
                    .item_nav{
                        text-align: center;
                        padding: 30px 0;
                        font-size: 20px;
                        font-weight: bold;
                        color: #333333;
                        border-bottom: 1px solid #EEEEEE;
                        cursor: pointer;
                        display: block;
                        transition: all .3s;
                        &:hover,&.active{
                            color: #3964E6;
                        }
                    }
                }
            }
        }
    }
}
/* fade-transform */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all .5s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>